"use client";

import React, { useEffect, useState } from "react";
import Fadeup from "../fadeup/Fadeup";
import { Link } from "react-router-dom";

const base_url = process.env.REACT_APP_BASE_URL;

const LatestNews = () => {
  const [newsData, setNewsData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchNews = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await fetch(`${base_url}/api/news/getNews?articleStatus=published`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        const result = await response.json();
        if (!response.ok) throw new Error(result.message || "Failed to fetch news");

        setNewsData(result.data || []);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchNews();
  }, []);

  return (
    <section className="latest-news-section">
      <div className="latest-news-wrapper">
        <Fadeup delay={0.3}>
          <h3 className="latest-news-heading">Explore the latest news below</h3>
        </Fadeup>

        {loading ? (
          <p className="text-center">Loading...</p>
        ) : error ? (
          <p className="text-center text-danger">Error: {error}</p>
        ) : (
          <div className="latest-news-grid">
            {newsData.map((news) => (
              <div className="news-card-wrapper" key={news.id}>
                <div className="news-card news-card--news cursor-pointer">
                  <Link to={`/newsdetailssection/${news.id}`}>
                    <div className="news-card-image-wrapper">
                      <img className="news-card-image" src={news.image} alt={news.title} />
                    </div>
                    <div className="news-card-body pb-0">
                      <h5 className="news-card-title text-black fw_600">{news.title}</h5>
                      <p className="news-card-text text-black">{news.description}</p>
                    </div>
                  </Link>
                  <div className="news-card-actions">
                    <Link to={`/newsdetailssection/${news.id}`} className="news-read-more">
                      Read more &rarr;
                    </Link>
                    {news.pdf && (
                      <a
                        href={news.pdf}
                        className="news-download"
                        target="_blank"
                        rel="noopener noreferrer"
                        download
                      >
                        Download PDF
                      </a>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}

        <div className="text-center mt-4">
          <Link
            to="/auction"
            className="btn btn-golden-glass  text-white position-relative overflow-hidden border-0"
          >
            <div
              className=" d-flex justify-content-center align-items-center"
            
            >
              <p className="m-0 text-black fw-bold button_name">View More</p>
            </div>
          </Link>
        </div>
      </div>
    </section>
  );
};

export default LatestNews;
